import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { useAppDispatch } from '@/redux/hooks';
import { submitUnfollowSeller } from '@/redux/modules/followSeller';

type Props = {
    browser?: ReactNode;
    className?: string;
    email?: ReactNode;
    frequency?: ReactNode;
    sellerId?: number;
    sms?: ReactNode;
    type?: ReactNode;
};

const TableRow = ({ browser, className, email, frequency, sellerId, sms, type }: Props) => {
    const dispatch = useAppDispatch();

    const unfollowSeller = React.useCallback(() => dispatch(submitUnfollowSeller(sellerId)), [dispatch, sellerId]);

    return (
        <RowContainer className={className}>
            <GridDiv $num={1}>{type}</GridDiv>
            {frequency && <HideOnMobile $num={2}>{frequency}</HideOnMobile>}
            {sms && <CenteredDiv $num={3}>{sms}</CenteredDiv>}
            {browser && <BrowserDiv $num={4}>{browser}</BrowserDiv>}
            <CenteredDiv
                $num={5}
                onClick={unfollowSeller}
            >
                {email}
            </CenteredDiv>
        </RowContainer>
    );
};

export default TableRow;

const GridDiv = styled.div<{ $num: number }>`
    ${({ $num }) => css`
        grid-column: ${$num} / ${$num + 1};
    `}
`;

const SlightlyCenteredDiv = styled(GridDiv)`
    align-self: center;
`;

const CenteredDiv = styled(SlightlyCenteredDiv)`
    justify-self: center;
    text-align: center;
`;

const BrowserDiv = styled(CenteredDiv)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        visibility: hidden;
        width: 0;
        height: 0;
    }
`;

const HideOnMobile = styled(SlightlyCenteredDiv)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        visibility: hidden;
        width: 0;
        height: 0;
    }
`;

const RowContainer = styled.div`
    display: grid;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    padding: 16px 0;
    grid-template-rows: auto;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        grid-template-columns: minMax(50px, 1fr) 0 50px 0 50px;
        label {
            margin-bottom: 0;
            padding-left: 0;
        }
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidthNum + 1}px) {
        grid-template-columns: minMax(50px, 1fr) 340px repeat(3, 70px);
        > * {
            padding: 0 6px;
        }
    }
`;
